import React, { useState } from 'react'
import { MuiGrid, MuiTypography } from '../../../ui/MaterialUIComponents';
import theme from '../../../../assests/theme';
import MasterScheduleForClass from './MasterScheduleForClass';
import MasterScheduleForTeacher from './MasterScheduleForTeacher'
import MasterScheduleForRoom from './MasterScheduleForRoom'
import MasterScheduleHeader from './MasterScheduleHeader'
import Table from "@material-ui/core/Table";

import TableContainer from '@material-ui/core/TableContainer';

import '../../../ui/scrollbarForLog.css'

import { makeStyles, withStyles } from '@material-ui/core/styles';
const useStyles = makeStyles(theme => ({
    rowTitleItemStyle: { fontWeight: 600 },
    rowTitleItemStyleBlur: { filter: 'blur(2px)', fontWeight: 600 },
    cellTextStyle: { fontSize: '10px', wordBreak: 'break-all' },
    cellTextStyleBlur: { fontSize: '10px', wordBreak: 'break-all', filter: 'blur(2px)' },
}));

export default function MasterSchedule(props) {
    let header = props.header
    let timeTable = props.timeTable;
    const classes = useStyles();
    function renderTime(time) {
        //let d1 = new Date(time)

        return time
    }
    function setTitleStyleBasedOnLicense(index1, index) {
        if (index1 >= index) {
            return classes.rowTitleItemStyle
        }
        else {
            return classes.rowTitleItemStyleBlur
        }

    }
    function setCellStyleBasedOnLicense(index1, index) {
        if (index1 >= index) {
            return classes.cellTextStyle
        }
        else {
            return classes.cellTextStyleBlur
        }

    }
    function getComponent(timeTableType) {

        switch (timeTableType) {
            case 'forTeacher': return <MasterScheduleForTeacher {...props}
                getCellStyle={getCellStyle}
                //getDayWidth={getDayWidth}
                setTitleStyleBasedOnLicense={setTitleStyleBasedOnLicense}
                setCellStyleBasedOnLicense={setCellStyleBasedOnLicense}
                timeTableForTeacher={props.timeTableForTeacher}
                renderTime={renderTime} />

                break;
            case 'forClass': return <MasterScheduleForClass {...props}
                getCellStyle={getCellStyle}
                //getDayWidth={getDayWidth} 
                timeTable={timeTable}
                setTitleStyleBasedOnLicense={setTitleStyleBasedOnLicense}
                setCellStyleBasedOnLicense={setCellStyleBasedOnLicense}
                renderTime={renderTime} />
                break;
            case 'forRooms': return <MasterScheduleForRoom {...props}
                getCellStyle={getCellStyle}
                //getDayWidth={getDayWidth} 
                setTitleStyleBasedOnLicense={setTitleStyleBasedOnLicense}
                setCellStyleBasedOnLicense={setCellStyleBasedOnLicense}
                roomsTimeTable={props.roomsTimeTable}
                renderTime={renderTime} />

                break;
            default: return 35
                break;
        }
    }

    function getCellStyle(period, day1, type, color, trialCheck, lastPeriod) {

        switch (period) {
            case 'lunch': return {

                borderBottom: !lastPeriod && type != 'cell' ? theme.palette.grey.dark : '',
                borderRight: lastPeriod ? '3px solid ' + theme.palette.grey.dark : '',
                background: theme.palette.grey.main,
                width: "12px",
                fontSize: 9,
                padding: 0,
                //  color: 'white',
                top: type != 'cell' ? 22 : null,
                height: type != 'cell' ? '5vh' : 'auto',
                zIndex: 1
            }; break;
            case 'break': return {
                background: theme.palette.grey.main,
                borderBottom: !lastPeriod && type != 'cell' ? theme.palette.grey.dark : '',
                borderRight: lastPeriod ? '3px solid ' + theme.palette.grey.dark : '',
                width: "3px",
                padding: 0,
                height: type != 'cell' ? '5vh' : 'auto',
                top: type != 'cell' ? 22 : null, zIndex: 1
            }; break;
            case 'unavailable': return {
                border: '1px solid ' + theme.palette.grey.dark,
                borderRight: lastPeriod ? '3px solid ' + theme.palette.grey.dark : '1px solid ' + theme.palette.grey.dark,
                backgroundImage:
                    "linear-gradient(120deg, #ffffff 31.25%, #b3b3b3 31.25%, #b3b3b3 50%, #ffffff 50%, #ffffff 81.25%, #b3b3b3 81.25%, #b3b3b3 100%)",
                backgroundSize: "9.24px 16.00px",
                minWidth: 35,
                filter: trialCheck ? 'blur(2px)' : '',
                height: type != 'cell' ? '5vh' : 'auto', zIndex: 1
            }; break;
            case 'slot': return {
                border: '1px solid ' + theme.palette.grey.dark,
                borderRight: lastPeriod ? '3px solid ' + theme.palette.grey.dark : '1px solid ' + theme.palette.grey.dark,
                width: 'auto', height: '1px',
                filter: trialCheck ? 'blur(2px)' : '',
                background: color,
                padding: 0,

                position: 'relative', zIndex: 1
            }; break;
            default:

                return {
                    border: '1px solid ' + theme.palette.grey.dark,
                    borderRight: lastPeriod ? '3px solid ' + theme.palette.grey.dark : '1px solid ' + theme.palette.grey.dark,
                    background: type != 'cell' ? 'white' : color,
                    minWidth: 35,
                    top: 22,
                    height: type != 'cell' ? '5vh' : 'auto', zIndex: 1
                }; break;
        }
    }

    return (

        <MuiGrid container style={{ border: '1px grey', paddingTop: '5px', flex: '1', flexDirection: 'row' }}>
            <TableContainer item xs={12} style={{ width: 'auto', height: props.height, overflow: 'auto', flex: '1' }} id='scrollStyle'>
                <Table

                    //border={1}
                    //borderColor='lightGrey'
                    padding='checkbox'
                    style={{ minWidth: 1150 }}
                    width='100%'
                    stickyHeader aria-label="sticky table"
                >
                    <MasterScheduleHeader
                        header={header}
                        renderTime={renderTime}
                        getCellStyle={getCellStyle}
                        style={{ position: 'fixed' }}
                        i18n={props.i18n} />

                    {getComponent(props.timeTableType)}

                </Table>
            </TableContainer>
        </MuiGrid>


    )

}
